import { ConversationDetailsContainer } from '@/modules/ConversationDetails';

export const ConversationDetails = (): JSX.Element => <ConversationDetailsContainer />;

export default ConversationDetails;
